module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"amountFilter":"Sum of sales","quantityFilter":"Number [pieces]","impressionsFilter":"Offers display","clicksFilter":"Clicks"}}')
  delete Component.options._Ctor
}
